import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { ContenidoStatus, Salutacion } from "src/common/contenido";
import { SalutacionActions, SalutacionActionTypes } from "./salutacion.actions";

export interface SalutacionState extends EntityState<Salutacion> {
	ready: boolean;
	nextPageNum: number;
	pageSize: number;
	status: ContenidoStatus;
	cleared: boolean;
}

export const salutacionAdapter: EntityAdapter<Salutacion> = createEntityAdapter<Salutacion>();

const initialSalutacionState: SalutacionState = salutacionAdapter.getInitialState({
	ready: true,
	nextPageNum: 0,
	pageSize: 5,
	status: null,
	cleared: false
});

export function salutacionReducer( state: SalutacionState = initialSalutacionState, action: SalutacionActions ): SalutacionState {
	let payload;
	let status: ContenidoStatus;

	switch( action.type ) {
		case SalutacionActionTypes.SalutacionPageRequested:
			return { ...state, cleared: false, ready: false };
		case SalutacionActionTypes.SalutacionPageLoaded:
			payload = action["payload"];
			let cleared: boolean = payload["cleared"];
			status = payload["status"];
			let salutacion: Salutacion[] = payload["salutacion"];

			if( cleared )
				state = salutacionAdapter.removeAll( state );

			return salutacionAdapter.addMany( salutacion, {
				...state,
				ready: true,
				status,
				cleared
			});
		case SalutacionActionTypes.SalutacionPageCancelled:
			payload = action["payload"];
			status = action["status"];

			// Si status == null => hubo un problema con el status, dejo el state como está			
			if( status != null && status.qty == 0 ) {
				state = salutacionAdapter.removeAll( state );
				state = { ...state, cleared: true, status };
			}

			return { ...state, ready: true };
		case SalutacionActionTypes.SalutacionPageRight:
			return { ...state, ready: true, cleared: false };
		default:
			return state;
	}	
};

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = salutacionAdapter.getSelectors();